const DIMENSIONS = {}

export default DIMENSIONS
